import { ErrorBoundary } from '@shared/ui/error-boundary';

import { BootGate } from './boot/boot-gate.ui';
import { AppProviders } from './providers/app-providers.ui';
import { AppRouter } from './router/app-router.ui';

/** 루트 ErrorBoundary → 프로바이더 → 부팅 게이트 → 라우터 */
export function App() {
  return (
    <ErrorBoundary name="root">
      <AppProviders>
        <BootGate>
          <AppRouter />
        </BootGate>
      </AppProviders>
    </ErrorBoundary>
  );
}
